import {
  Ved as VedIcon,
  Bill as BillIcon,
  Card as CardIcon,
  Info as InfoIcon,
  List as ListIcon,
  Mail as MailIcon,
  User as UserIcon,
  Credit as CreditIcon,
  Deposit as DepositIcon,
  Document as DocumentIcon,
  Accounts as AccountsIcon,
  Acquiring as AcquiringIcon,
  Invoices as InvoicesIcon,
  Settings as SettingsIcon,
  Analytics as AnalyticsIcon,
  Requisites as RequisitesIcon,
  TariffPlans as TariffPlansIcon,
  SalaryProject as SalaryProjectIcon,
  Showcase as ShowcaseIcon,
  LoyaltyProgram as LoyaltyProgramIcon,
  NoteBoard as NoteBoardIcon,
  Desktop as DesktopIcon,
  Statement as StatementIcon,
  IssueInvoice as IssueInvoiceIcon,
  Calendar as CalendarIcon,
  UserGroup as UserGroupIcon,
  SrBill as SrBillIcon,
  SrCoin as SrCoinIcon,
  BrokerService as BrokerServiceIcon,
  ChatMessage as SwiftMessagesIcon,
} from "@rshbintech.dboul/icons";
import { SbpSmall as SbpSmallImage } from "@rshbintech.dboul/images";
import { MenuConfig } from "../types";

export const MENU_CONFIG: MenuConfig = {
  top: [
    {
      name: "Счета и платежи",
      translateCode: "ITEMS.TOP.ACCOUNTS_AND_PAYMENTS",
      path: "/main/accounts",
      icon: AccountsIcon,
      dataTestId: "accounts-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__accounts",
      featureName: "accounts-menu-item",
      disabled: false,
    },
    {
      name: "Счета на оплату",
      path: "/invoices",
      icon: InvoicesIcon,
      dataTestId: "invoices-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__invoices",
      featureName: "invoices-menu-item",
      disabled: false,
    },
    {
      name: "Выписка",
      translateCode: "ITEMS.TOP.STATEMENT",
      path: "/statements",
      icon: BillIcon,
      dataTestId: "statements-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__statements",
      featureName: "statements-menu-item",
      disabled: false,
    },
    {
      name: "Шаблоны",
      path: "/payments/templates",
      icon: ListIcon,
      dataTestId: "templates-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__templates",
      featureName: "templates-menu-item",
      disabled: false,
    },
    {
      name: "Своя Корпорация",
      path: "/rck",
      icon: IssueInvoiceIcon,
      dataTestId: "rck-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__rck",
      featureName: "rck-menu-item",
      disabled: false,
      additionalItems: [
        {
          name: "Визирование",
          path: "/rck/signing",
          icon: SrBillIcon,
          dataTestId: "rck-submenu-signing-item",
          metricName: "sb-menu--item-click",
          metricData: "menu__rck__signing",
          featureName: "rck-submenu-signing-item",
          disabled: false,
        },
        {
          name: "Холдинг. Выписка",
          path: "/rck/group-balance",
          icon: SrCoinIcon,
          dataTestId: "rck-submenu-holding-balances-item",
          metricName: "sb-menu--item-click",
          metricData: "menu__rck__holding-balances",
          featureName: "rck-submenu-holding-balances-item",
          disabled: false,
        },
      ],
    },
    {
      name: "Аналитика",
      path: "/analytics",
      icon: AnalyticsIcon,
      dataTestId: "analytics-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__analytics",
      featureName: "analytics-menu-item",
      disabled: false,
    },
    {
      name: "Контрагенты",
      translateCode: "ITEMS.TOP.COUNTERPARTIES",
      path: "/counterparties",
      icon: UserIcon,
      dataTestId: "counterparties-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__counterparties",
      featureName: "counterparties-menu-item",
      disabled: false,
    },
    {
      name: "SWIFT сообщения",
      translateCode: "ITEMS.TOP.SWIFT_MESSAGES",
      path: "/swift-messages",
      icon: SwiftMessagesIcon,
      dataTestId: "swift-messages-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__swift-messages",
      featureName: "swift-messages-menu-item",
      disabled: false,
    },
    {
      name: "Тарифы",
      path: "/tariffs",
      icon: TariffPlansIcon,
      dataTestId: "tariffs-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__tariffs",
      featureName: "tariffs-menu-item",
      disabled: false,
    },
    {
      name: "Справки",
      path: "/references",
      icon: DocumentIcon,
      dataTestId: "references-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__references",
      featureName: "references-menu-item",
      disabled: false,
    },
    {
      name: "Заявки",
      path: "/showcase/orders",
      icon: IssueInvoiceIcon,
      dataTestId: "orders-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__orders",
      featureName: "orders-menu-item",
      disabled: false,
    },
    {
      name: "Реестры",
      path: "/registries",
      icon: DocumentIcon,
      dataTestId: "registries-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__registries",
      featureName: "registries-menu-item",
      disabled: false,
    },
    {
      name: "Реестры по ном. счетам",
      path: "/write-off-registers",
      icon: DocumentIcon,
      dataTestId: "write-off-registries-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__write-off-registries",
      featureName: "write-off-registries-menu-item",
      disabled: false,
    },
    {
      name: "СБП",
      path: "/sbp",
      icon: SbpSmallImage,
      dataTestId: "sbp-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__sbp",
      featureName: "sbp-menu-item",
      disabled: false,
    },
  ],
  middle: [
    {
      name: "Зарплатный проект",
      path: "/salary",
      icon: SalaryProjectIcon,
      dataTestId: "salary-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__salary",
      featureName: "salary-menu-item",
      disabled: false,
    },
    {
      name: "Бизнес-карты",
      path: "/cards",
      icon: CardIcon,
      dataTestId: "cards-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__cards",
      featureName: "cards-menu-item",
      disabled: false,
    },
    {
      name: "Депозиты",
      path: "/deposits",
      icon: DepositIcon,
      dataTestId: "deposits-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__deposits",
      featureName: "deposits-menu-item",
      disabled: false,
    },
    {
      name: "Бухгалтерия «Моё дело»",
      path: "/my-business",
      icon: DocumentIcon,
      dataTestId: "my-business-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__my-business",
      featureName: "my-business-menu-item",
      disabled: false,
    },
    {
      name: "Эквайринг",
      path: "/acquiring",
      icon: AcquiringIcon,
      dataTestId: "acquiring-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__acquiring",
      featureName: "acquiring-menu-item",
      disabled: false,
    },
    {
      name: "ВЭД",
      path: "/foreign-activity",
      icon: VedIcon,
      dataTestId: "foreign-activity-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__foreign-activity",
      featureName: "foreign-activity-menu-item",
      disabled: false,
    },
    {
      name: "Аккредитивы",
      translateCode: "ITEMS.TOP.ACCREDITIVS",
      path: "/accreditivs",
      icon: DocumentIcon,
      dataTestId: "accreditivs-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__accreditivs",
      featureName: "accreditivs-menu-item",
      disabled: false,
    },
    {
      name: "Кредиты",
      path: "/loans",
      icon: CreditIcon,
      dataTestId: "loans-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__loans",
      featureName: "loans-menu-item",
      disabled: false,
    },
    {
      name: "Брокерское обслуживание",
      translateCode: "ITEMS.MIDDLE.BROKERAGE_SERVICES",
      path: "/brokerage-services",
      icon: BrokerServiceIcon,
      dataTestId: "brokerage-services-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__brokerage-services",
      featureName: "brokerage-services-menu-item",
      disabled: false,
    },
    {
      name: "Все сервисы",
      path: "/showcase",
      icon: ShowcaseIcon,
      dataTestId: "showcase-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__showcase",
      featureName: "showcase-menu-item",
      disabled: false,
    },
    {
      name: "Программа лояльности",
      path: "/loyalty-program",
      icon: LoyaltyProgramIcon,
      dataTestId: "loyalty-program-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__loyalty-program",
      featureName: "loyalty-program-menu-item",
      disabled: false,
    },
    {
      name: "АУСН",
      path: "/ausn",
      icon: RequisitesIcon, // Необходимо обсудить с дизайнерами целевую иконку для данного проекта
      dataTestId: "ausn-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__ausn",
      featureName: "ausn-menu-item",
      disabled: false,
    },
    {
      name: "Сертификат НРД",
      path: "/nsd-certificate",
      icon: DocumentIcon,
      dataTestId: "nsd-certificate-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__nsd-certificate",
      featureName: "nsd-certificate-menu-item",
      disabled: false,
    },
    {
      name: "Реестры абонентов",
      path: "/cash-management/espp",
      icon: DocumentIcon,
      dataTestId: "cash-management-espp-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__cash-management-espp",
      featureName: "cash-management-espp-menu-item",
      disabled: false,
    },
    {
      name: "Отчёты по счетам эскроу",
      path: "/cash-management/escrow-report",
      icon: SrBillIcon,
      dataTestId: "cash-management-escrow-report-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__cash-management-escrow-report",
      featureName: "cash-management-escrow-report-menu-item",
      disabled: false,
    },
  ],
  saas: [
    {
      name: "Конструктор сайтов",
      path: "/crm/websites-constructor",
      icon: DesktopIcon,
      dataTestId: "crm-websites-constructor-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__crm-websites-constructor",
      featureName: "crm-websites-constructor-menu-item",
      disabled: false,
    },
    {
      name: "CRM",
      path: "",
      icon: NoteBoardIcon,
      dataTestId: "crm-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__crm",
      additionalItems: [
        {
          name: "Сделки",
          path: "/crm/deals",
          icon: StatementIcon,
          dataTestId: "crm-deals-menu-item",
          metricName: "sb-menu--item-click",
          metricData: "menu__crm-deals",
          featureName: "crm-deals-menu-item",
          disabled: false,
        },
        {
          name: "Календарь",
          path: "/crm/calendar",
          icon: CalendarIcon,
          dataTestId: "crm-calendar-menu-item",
          metricName: "sb-menu--item-click",
          metricData: "menu__crm-calendar",
          featureName: "crm-calendar-menu-item",
          disabled: false,
        },
        {
          name: "Товары и услуги",
          path: "/crm/goods-and-services",
          icon: NoteBoardIcon,
          dataTestId: "crm-goods-and-services-menu-item",
          metricName: "sb-menu--item-click",
          metricData: "menu__crm-goods-and-services",
          featureName: "crm-goods-and-services-menu-item",
          disabled: false,
        },
        {
          name: "Контакты",
          path: "/crm/contacts",
          icon: UserGroupIcon,
          dataTestId: "crm-contacts-menu-item",
          metricName: "sb-menu--item-click",
          metricData: "menu__crm-contacts",
          featureName: "crm-contacts-menu-item",
          disabled: false,
        },
      ],
      featureName: "crm-menu-item",
      disabled: false,
    },
  ],
  bottom: [
    {
      name: "Письма",
      translateCode: "ITEMS.BOTTOM.MAIL",
      path: "/messages",
      icon: MailIcon,
      dataTestId: "messages-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__messages",
      featureName: "messages-menu-item",
      disabled: false,
    },
    {
      name: "Помощь",
      path: "/help",
      icon: InfoIcon,
      dataTestId: "help-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__help",
      featureName: "help-menu-item",
      disabled: false,
    },
    {
      name: "Настройки",
      path: "/settings",
      icon: SettingsIcon,
      dataTestId: "settings-menu-item",
      metricName: "sb-menu--item-click",
      metricData: "menu__settings",
      featureName: "settings-menu-item",
      disabled: true,
    },
  ],
};
